import React from "react";

import { useIntl } from "react-intl";

import { Activity } from "@mapmycustomers/shared/types/entity";
import { stopEvents } from "@mapmycustomers/shared/util/browser";
import { AvatarWithName } from "@mapmycustomers/ui";

import UserPreviewCard from "@app/component/UserPreviewCard";

import styles from "./ActivityOwnerAssignee.module.scss";
import messages from "./messages";

interface ActivityOwnerAssigneeProps {
  activity: Activity;
}

const ActivityOwnerAssignee = ({ activity }: ActivityOwnerAssigneeProps) => {
  const intl = useIntl();

  return (
    <div className={styles.container}>
      <div className={styles.field}>
        <span className={styles.label}>{intl.formatMessage(messages.owner)}</span>
        <div className={styles.userValue} onClick={stopEvents}>
          <UserPreviewCard userId={activity.user.id}>
            <div>
              <AvatarWithName actionOnHover size="xs" user={activity.user} />
            </div>
          </UserPreviewCard>
        </div>
      </div>
      {activity.assignee && (
        <div className={styles.field}>
          <span className={styles.label}>{intl.formatMessage(messages.assignee)}</span>
          <div className={styles.userValue} onClick={stopEvents}>
            <UserPreviewCard userId={activity.assignee.id}>
              <div>
                <AvatarWithName actionOnHover size="xs" user={activity.assignee} />
              </div>
            </UserPreviewCard>
          </div>
        </div>
      )}
    </div>
  );
};

export default ActivityOwnerAssignee;
